import { useMemo } from 'react'

import { MasterCampaignPlanCampaignBuilderType, MasterCampaignStub, PostalCodeTarget } from 'api/entities/MasterCampaignStub'

export const useZipCodesByType = (masterCampaignStub: MasterCampaignStub | undefined, campaignTypes: MasterCampaignPlanCampaignBuilderType[]): string[] => {
  return useMemo((): string[] => {
    if (!masterCampaignStub?.campaignBuilders) {
      return []
    }

    const allZips: Set<string> = new Set()
    masterCampaignStub.campaignBuilders.forEach(campaign => {
      if (!campaign.zips || !campaignTypes.includes(campaign.campaignType)) {
        return
      }

      campaign.zips.forEach((zip: PostalCodeTarget) => {
        if (zip.code) {
          allZips.add(zip.code)
        }
      })
    })

    return Array.from(allZips)
  }, [masterCampaignStub])
}

export const useBillboardZipCodes = (masterCampaignStub: MasterCampaignStub | undefined): string[] => {
  return useZipCodesByType(masterCampaignStub, [MasterCampaignPlanCampaignBuilderType.Billboard])
}

export const useHouseholdZipCodes = (masterCampaignStub: MasterCampaignStub | undefined): string[] => {
  return useMemo((): string[] => {
    if (!masterCampaignStub?.campaignBuilders) {
      return []
    }

    const allZips: Set<string> = new Set()
    masterCampaignStub.campaignBuilders.forEach(campaign => {
      if (!campaign.zips) {
        return
      }

      const isInternet = campaign.campaignType === MasterCampaignPlanCampaignBuilderType.Internet
      const isTV = campaign.campaignType === MasterCampaignPlanCampaignBuilderType.TV
      const isOffAdCritterWithProjectionsAndGeoHeatmap = campaign.campaignType === MasterCampaignPlanCampaignBuilderType.OffAdCritter && campaign.includeInProjections && campaign.includeInGeoHeatmap

      if (!isInternet && !isTV && !isOffAdCritterWithProjectionsAndGeoHeatmap) {
        return
      }

      campaign.zips.forEach((zip: PostalCodeTarget) => {
        if (zip.code) {
          allZips.add(zip.code)
        }
      })
    })

    return Array.from(allZips)
  }, [masterCampaignStub])
}
